import { v } from '@/lib/validator';

export default v.object().shape({
  email: v.string().email('Email is not valid').required('Email is required'),
  newPassword: v.string().required('New password is required'),
  temporaryPassword: v.string().required('Temporary password is required'),
});
